import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  signal,
  ViewEncapsulation,
} from '@angular/core';

import {
  FaceDataModel,
  Facet,
  FilterSelection,
} from '@fantaz/shared/data-access/models';

type PanelGroup = FaceDataModel & {
  key: string;
};

@Component({
  selector: 'fz-filter-panel',
  templateUrl: './filter-panel.html',
  styleUrls: ['./filter-panel.scss'],
  host: {
    class: 'fz-filter-panel',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterPanel {
  readonly #logger = {
    log: (message: string) => console.log(`FilterPanel: ${message}`),
  };
  facet = input.required<Facet>();
  filters = input<FilterSelection>({});
  filterChange = output<FilterSelection>();
  clear = output<void>();

  selection = signal<FilterSelection>({});

  items = computed<PanelGroup[]>(() => {
    return Object.keys(this.facet()).map((key) => ({
      key,
      ...this.facet()[key],
    }));
  });

  countUserSelections = computed(() => {
    return Object.values(this.filters()).reduce(
      (acc, val) => acc + val.filter((k) => k !== '').length,
      0,
    );
  });

  removeSelection(data: { group: string; key: string }) {
    this.#logger.log(`Remove Selection: ${data.key}`);
    this.filterChange.emit({
      ...this.filters(),
      [data.group]: this.filters()[data.group].filter((k) => k !== data.key),
    });
  }

  selectionChange(changes: FilterSelection) {
    this.filterChange.emit(changes);
  }
}
